import { parseStringPromise } from 'xml2js';

function asArray<T>(x: T | T[] | undefined | null): T[] {
  if (x == null) return [];
  return Array.isArray(x) ? x : [x];
}

/** Collect Placemark from a Folder and any nested Folder (KML allows nested folders). */
function collectPlacemarksFromFolder(folder: any, out: any[]): void {
  if (!folder || typeof folder !== 'object') return;
  const placemarks = folder.Placemark;
  if (placemarks) {
    out.push(...asArray(placemarks));
  }
  const nested = folder.Folder;
  if (nested) {
    const nestedFolders = asArray(nested);
    for (let i = 0; i < nestedFolders.length; i += 1) {
      collectPlacemarksFromFolder(nestedFolders[i], out);
    }
  }
}

function getPlacemarksFromKml(result: any): any[] {
  const out: any[] = [];
  const kml = result && result.kml;
  const doc = kml && kml.Document;

  if (doc && doc.Folder) {
    const folders = asArray(doc.Folder);
    for (let i = 0; i < folders.length; i += 1) {
      collectPlacemarksFromFolder(folders[i], out);
    }
  }
  if (doc && doc.Placemark) {
    out.push(...asArray(doc.Placemark));
  }
  if (kml && kml.Placemark) {
    out.push(...asArray(kml.Placemark));
  }
  return out;
}

function parseCoordinatesString(coordStr: string) {
  const formattedCoords: number[][] = [];
  const coordinates: number[][] = [];
  const str = coordStr != null ? coordStr : '';
  const lines = str
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  for (let i = 0; i < lines.length; i += 1) {
    const line = lines[i];
    const parts = line.split(',').map(Number);
    const lon = parts[0];
    const lat = parts[1];
    if (Number.isFinite(lon) && Number.isFinite(lat)) {
      formattedCoords.push([lon, lat]);
      coordinates.push([lat, lon]);
    }
  }
  return { formattedCoords, coordinates };
}

export async function parseKmlToFences(xmlString: string) {
  const result = await parseStringPromise(xmlString, { explicitArray: false });

  const placemarkArray = getPlacemarksFromKml(result);
  if (!placemarkArray.length) return [];

  const parsed: any[] = [];
  for (let i = 0; i < placemarkArray.length; i += 1) {
    const placemark = placemarkArray[i];
    const nameContent = placemark.name;
    let fenceName = 'Sem nome';
    if (typeof nameContent === 'string') {
      fenceName = nameContent;
    } else if (nameContent && nameContent._) {
      fenceName = nameContent._;
    } else if (nameContent && nameContent[0]) {
      fenceName = nameContent[0];
    }

    let formattedCoords: number[][] = [];
    let coordinates: number[][] = [];
    const polygon =
      placemark.Polygon ||
      (placemark.MultiGeometry && placemark.MultiGeometry.Polygon);
    if (
      polygon &&
      polygon.outerBoundaryIs &&
      polygon.outerBoundaryIs.LinearRing &&
      polygon.outerBoundaryIs.LinearRing.coordinates
    ) {
      const coordStr = polygon.outerBoundaryIs.LinearRing.coordinates.trim();
      const parsedCoords = parseCoordinatesString(coordStr);
      formattedCoords = parsedCoords.formattedCoords;
      coordinates = parsedCoords.coordinates;
    }

    parsed.push({
      nome: String(fenceName).trim(),
      coordinates,
      formattedCoords,
      veiculos: [],
      ativo: true,
      pontosBase: [],
    });
  }

  const filtered = parsed.filter(f => f.formattedCoords.length > 0);
  filtered.sort((f1, f2) => (f1.nome < f2.nome ? -1 : 1));
  return filtered;
}
